export const statusOptions = [
  {
    label: "Documents",
    value: "1",
  },
  // {
  //     label: 'Preparation',
  //     value: '2'
  // },
  {
    label: "Preparation",
    value: "3",
  },
  {
    label: "Payments",
    value: "4",
  },
  {
    label: "Filing",
    value: "6",
  },
  {
    label: "Completed",
    value: "7",
  },
];

export const departmentOptions = [
  {
    label: "Documents",
    value: "2",
  },
  // {
  //     label: 'Preparation',
  //     value: '3'
  // },
  {
    label: "Preparation",
    value: "4",
  },
  {
    label: "Payments",
    value: "5",
  },
  {
    label: "Filing",
    value: "6",
  },
];
export const sourceOptions = [
  {
    label: "Web",
    value: "Web",
  },
  {
    label: "Existing",
    value: "Existing",
  },
  {
    label: "New",
    value: "New",
  },
  {
    label: "Referal",
    value: "Referal",
  },
  {
    label: "Reopen",
    value: "Reopen",
  },
];
